export default __webpack_public_path__ + "static/media/coinbase-wallet-logo.b07b5b36.png";